import React from 'react'
import { Breadcrumb } from '../../../components'

interface BreadcrumbItem {
  label: string
  path: string
  isActive?: boolean
}

interface ToolkitPageLayoutProps {
  children: React.ReactNode
  title?: string
  subtitle?: string
  breadcrumbs?: BreadcrumbItem[]
  className?: string
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full'
  showBreadcrumbs?: boolean
}

export const ToolkitPageLayout: React.FC<ToolkitPageLayoutProps> = ({
  children,
  title,
  subtitle,
  breadcrumbs,
  className = '',
  maxWidth = 'xl',
  showBreadcrumbs = true
}) => {
  const maxWidthClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-7xl',
    '2xl': 'max-w-2xl',
    full: 'max-w-full'
  }

  return (
    <div className={`min-h-screen bg-[#EDE6DE] ${className}`}>
      <div
        className={`mx-auto px-4 sm:px-6 lg:px-8 py-6 ${maxWidthClasses[maxWidth]}`}
      >
        {/* Breadcrumbs */}
        {showBreadcrumbs && (
          <div className="mb-6">
            <Breadcrumb customItems={breadcrumbs} className="mb-4" />
          </div>
        )}

        {/* Page Header */}
        {(title || subtitle) && (
          <header className="mb-8">
            {title && (
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif text-[#3C2416] mb-4 leading-tight">
                {title}
              </h1>
            )}
            {subtitle && (
              <p className="text-lg md:text-xl text-[#713d43] leading-relaxed max-w-4xl">
                {subtitle}
              </p>
            )}
          </header>
        )}

        {/* Main Content */}
        <main className="space-y-8">{children}</main>
      </div>
    </div>
  )
}
